module.exports = __webpack_public_path__ + "img/mob4.cdc215ed.png";